<template>
  <nav class="w-full flex justify-between gap-6 mb-2 bg-white"
  :class="typeContainer">
    <div class="lg:w-2/6">
      <a
        href="https://www.superfinanciera.gov.co/"
        target="_blank"
        rel="noopener"
        class ="h-full block" 
      >
      <img
          src="@/assets/img/logo-sfc.png"
          style="height: 50px !important;"
          alt="Potencia Vida"
        />
      </a>
    </div>
    <NavbarUserItem class="lg:w-4/6" v-if="havePermissions"/>
  </nav>
</template>

<script>
import LogoSFC from "@/components/Brand/LogoSFC";
import NavbarUserItem from "./NavbarUserItem.vue";
export default {
  props: {
    typeContainer: {
      type: String,
      default: 'container',
      required: false,
    }
  },
  components: {
    LogoSFC,
    NavbarUserItem,
  },
  computed: {
    havePermissions: function () {
      return this.$store.state.session.modules?.length > 0;
    },
  },
};
</script>